// Logos for the testimonials (the Supabase `testimonials` list, src/hooks/useTestimonials.ts), by the company in the
// testimonial's role ("Race Director, Big Bear Events" → "Big Bear Events").
//
// Rules (owner, 27 Oct 2026): only the customer's OWN logo, as their workspace uses it on Photohawk (their gallery
// branding) or as they supply it; never a logo redrawn, guessed or downloaded from elsewhere, and never a logo for
// anyone without an existing testimonial. Until a company's logo is here, its card shows the company name set in
// type instead (src/components/TestimonialLogo.tsx), so nothing pretends to be their logo.
//
// To add one: put the file in src/assets/testimonials/<kebab-company>.{svg,png,webp} (transparent background, at
// least 160 px tall for raster), import it below and add { src, width, height } under the company's exact name.
//
// Testimonials with no logo yet (27 Oct 2026): My Sport Photos, Big Bear Events, Mel Parry Events, SportpicturesCymru.

export interface TestimonialLogo {
  src: string;
  width: number;
  height: number;
  /** Logos drawn for dark backgrounds (white marks) get a dark tile. */
  onDark?: boolean;
}

export const TESTIMONIAL_LOGOS: Record<string, TestimonialLogo> = {};

/** The company in a testimonial's role: the part after the first comma ("Owner, Mel Parry Events" → "Mel Parry Events"). */
export const companyOf = (role: string): string | null => {
  const i = role.indexOf(",");
  const company = i >= 0 ? role.slice(i + 1).trim() : "";
  return company || null;
};

/** The job title in a testimonial's role ("Race Director, Big Bear Events" → "Race Director"). */
export const titleOf = (role: string): string => {
  const i = role.indexOf(",");
  return (i >= 0 ? role.slice(0, i) : role).trim();
};

export const logoFor = (role: string): TestimonialLogo | null => {
  const company = companyOf(role);
  return (company && TESTIMONIAL_LOGOS[company]) || null;
};
